import { render, staticRenderFns } from "./CertificatConsultation.vue?vue&type=template&id=788229b2&scoped=true&"
import script from "./CertificatConsultation.vue?vue&type=script&lang=js&"
export * from "./CertificatConsultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788229b2",
  null
  
)

export default component.exports